import { ref, computed } from '@vue/composition-api'
import prizesApi from '@/services/api/prizes'
import EventBus from '@/store/EventBus'

function mapPlace(p) {
  return {
    id: p.id,
    place: p.place_name,
    rider: p.member,
    riderDeleted: p.member_deleted,
    horse: p.horse,
    horseDeleted: p.horse_deleted,
    owner: p.owner,
    score: p.score,
    payout: p.amount != null ? p.amount.toFixed(2) : '0.00'
  }
}

function mapRound(r) {
  return {
    id: r.calc_round_id,
    label: r.is_final ? 'Final round' : `Round ${r.order}`,
    isFinal: r.is_final,
    competitors: r.places_number,
    payingPlaces: r.places_number,
    judges: r.judge_name != null ? r.judge_name : '',
    totalPayouts: r.total_payouts != null ? r.total_payouts.toFixed(2) : '0.00',
    results: (r.places != null ? r.places : []).map(mapPlace)
  }
}

function mapCutout(c) {
  return {
    id: c.id,
    rider: c.member_name,
    horse: c.horse_name,
    cutoutScore: c.cutout,
    isWinner: c.is_winner,
    drawId: c.id
  }
}

export default function usePrizesView(eventId) {
  const rounds = ref([])
  const roundsData = ref({})
  const cutouts = ref([])
  const eventName = ref('')
  const activeRound = ref(null)
  const loading = ref(false)

  const activeRoundData = computed(() => {
    if (activeRound.value == null) return null
    return roundsData.value[activeRound.value] != null
      ? roundsData.value[activeRound.value]
      : null
  })

  async function fetchPrizes() {
    loading.value = true
    try {
      const res = await prizesApi.getPrizes(eventId)
      const d = res.data.data
      const apiRounds = d.rounds != null ? d.rounds : []
      const mapped = apiRounds.map(mapRound)

      rounds.value = mapped.map(r => ({ id: r.id, label: r.label, isFinal: r.isFinal }))

      const dataMap = {}
      mapped.forEach((r) => { dataMap[r.id] = r })
      roundsData.value = dataMap

      cutouts.value = (d.cutOutsList != null ? d.cutOutsList : []).map(mapCutout)
      eventName.value = d.eventName != null ? d.eventName : ''

      if (mapped.length > 0 && activeRound.value == null) {
        activeRound.value = mapped[0].id
      }
    } catch (_) {
      rounds.value = []
      roundsData.value = {}
      cutouts.value = []
    } finally {
      loading.value = false
    }
  }

  async function setWinner(cutout) {
    try {
      await prizesApi.setCutoutWinner(eventId, cutout.drawId)
      cutouts.value.forEach((c) => { c.isWinner = false })
      const target = cutouts.value.find(c => c.id === cutout.id)
      if (target) target.isWinner = true
    } catch (_) { /* http.js handles toast */ }
  }

  const downloadingPdf = ref(false)

  async function downloadPdf() {
    if (downloadingPdf.value) return
    downloadingPdf.value = true
    try {
      const res = await prizesApi.getFinalPdf(eventId)
      const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
      window.open(blobUrl, '_blank')
    } catch (_) {
      EventBus.$emit('http-error', 'Failed to download PDF')
    } finally {
      downloadingPdf.value = false
    }
  }

  return {
    rounds,
    activeRound,
    activeRoundData,
    cutouts,
    eventName,
    loading,
    downloadingPdf,
    fetchPrizes,
    setWinner,
    downloadPdf
  }
}



// WEBPACK FOOTER //
// ./src/composables/prizes/usePrizesView.js